module.exports = __webpack_public_path__ + "img/icon-new-project.36d09116.svg";